import { useNavigate, useSearchParams } from 'react-router-dom'
import SearchBar from '@/components/SearchBar'
import ProductCard from '@/components/ProductCard'
import Skeleton from '@/components/Skeleton'
import { useSearch } from '@/hooks/useSearch'

export default function SearchResults() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const q = params.get('q') ?? ''

  const { results, loading } = useSearch(q)

  return (
    <div className="max-w-7xl mx-auto px-4 py-4 pb-8">
      <div className="mb-4">
        <SearchBar
          defaultValue={q}
          onSearch={query => navigate(`/search?q=${encodeURIComponent(query)}`)}
        />
      </div>

      <p className="text-xs text-gray-400 mb-4">
        {loading ? 'Mencari...' : `${results.length} hasil untuk "${q}"`}
      </p>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} className="h-52" />
          ))}
        </div>
      ) : results.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <p className="text-lg font-medium">Produk tidak ditemukan</p>
          <p className="text-sm mt-1">Coba kata kunci lain</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {results.map(p => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  )
}
